(() => {
  window.park.eventHub.register('click', '.park-calendar__control button', (e) => {
    const content = document.querySelector('.park-calendar__content');
    if (!content) {
      return;
    }
    if (content.getAttribute('aria-hidden') === 'false' || content.getAttribute('aria-hidden') === null) {
      content.setAttribute('aria-hidden', 'true');
    } else {
      content.setAttribute('aria-hidden', 'false');
      e.currentTarget.setAttribute('aria-hidden', 'true');
    }
  });
})();
